import { Suspense } from 'react'

import { Layout, SpinnerWheel, Text } from '@loadsmart/miranda-react'

import Fallback from './Fallback'
import { ToastContainer } from './ToastContainer'
import { useOpendockAuthRedirect } from 'auth/ui/hooks/useOpendockAuthRedirect'
import Router from '../Router'

/**
 * Component that wraps the Router and handles OpenDock authentication redirects.
 * This must be inside BrowserRouter to access router context.
 */
export default function AppWithAuth() {
  // Handle OpenDock authentication redirect BEFORE Router renders
  // This ensures tokens are mapped before any component clears localStorage
  const isProcessingOpendockAuth = useOpendockAuthRedirect()

  // Show loading state while processing OpenDock auth to prevent HomePage from flashing
  if (isProcessingOpendockAuth) {
    return (
      <Layout.Stack justify="center" align="center" style={{ margin: 'auto', height: '100vh' }}>
        <Text variant="heading-sm-bold">Authenticating...</Text>
        <SpinnerWheel size="48" />
      </Layout.Stack>
    )
  }

  return (
    <Suspense fallback={<Fallback />}>
      <Router />
      <ToastContainer />
    </Suspense>
  )
}

